/* Serené Le Parfum — Widget de chat "Mojo"  ·  v3 (contexto en vivo + proactivo)
 * v4 (2026-10-02): nivel 3 — botones de acción (agregar al carrito, ver carrito, finalizar compra).
 * v3 (2026-10-02): renombrado Aura → Mojo; manda al agente el contexto de la visita
 *   (página, producto, carrito, vistos) y abre conversación proactiva ante señales de duda.
 * v2 (mobile-first)
 * Vanilla JS, sin dependencias. Inyecta botón flotante + ventana de chat.
 * Uso: <script src="https://TU-WORKER.workers.dev/widget.js" data-endpoint="https://TU-WORKER.workers.dev/chat"></script>
 * O define window.SERENE_CHAT_ENDPOINT antes de cargar el script.
 *
 * v2 — mejoras de responsive / UX móvil:
 *  • El teclado ya no tapa el input: se ajusta la altura con visualViewport.
 *  • La página deja de moverse por detrás: scroll-lock del body al abrir.
 *  • Respeta el notch/barra de estado (safe-area-inset) arriba y abajo.
 *  • Sin scroll horizontal (100% en vez de 100vw), animación de apertura,
 *    áreas táctiles ≥44px, scroll contenido (overscroll-behavior).
 */
(function () {
  "use strict";

  // ── Config ──────────────────────────────────────────────────────────
  var script = document.currentScript;
  var ENDPOINT =
    (script && script.getAttribute("data-endpoint")) ||
    window.SERENE_CHAT_ENDPOINT ||
    "http://127.0.0.1:8787/chat";
  var STORAGE_KEY = "serene_chat_history_v2"; // v2 = Mojo (no arrastra saludos de Aura)
  var BRAND = "#1a1a2e";       // color principal (header/botón)
  var ACCENT = "#c9a227";      // dorado Serené
  var FAB_LABEL = "Comprar con IA";
  var SHOW_FAB = !(script && script.getAttribute("data-fab") === "false");
  var WHATSAPP_URL = "https://wa.link/zqis96";
  var GREETING =
    "¡Hola! Soy Mojo, tu asesor personal de fragancias Serené ✨\n\n" +
    "Para encontrar el perfume ideal para ti, me gustaría hacerte unas pocas preguntas sobre tus gustos, tu estilo y la ocasión. Así puedo recomendarte las fragancias que mejor se adaptan a tu personalidad.\n\n" +
    "¿Comenzamos? Cuéntame: ¿buscas una fragancia **para ti** o **para regalar**?";

  // ── Estado ──────────────────────────────────────────────────────────
  var messages = loadHistory();
  var isOpen = false;
  var isStreaming = false;
  var savedScrollY = 0;
  var vv = window.visualViewport || null;

  function isMobile() {
    return window.matchMedia("(max-width:600px)").matches;
  }

  function loadHistory() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch (e) {}
    return [];
  }
  function saveHistory() {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(messages.slice(-20)));
    } catch (e) {}
  }

  // ── Estilos ─────────────────────────────────────────────────────────
  var css =
    "" +
    /* Botón flotante */
    ".srn-fab{position:fixed;bottom:calc(18px + env(safe-area-inset-bottom,0px));right:18px;height:54px;padding:0 22px;border-radius:30px;background:" + BRAND + ";color:#fff;border:1.5px solid " + ACCENT + ";cursor:pointer;box-shadow:0 6px 22px rgba(0,0,0,.32);z-index:2147483646;display:flex;align-items:center;gap:9px;font-family:inherit;font-size:15px;font-weight:600;letter-spacing:.3px;transition:transform .2s,box-shadow .2s;-webkit-tap-highlight-color:transparent}" +
    ".srn-fab:hover{transform:translateY(-2px);box-shadow:0 9px 26px rgba(0,0,0,.38)}" +
    ".srn-fab:active{transform:scale(.97)}" +
    ".srn-fab svg{width:22px;height:22px;flex-shrink:0;color:" + ACCENT + "}" +
    ".srn-fab .srn-fab-label{white-space:nowrap}" +
    "@media(max-width:600px){.srn-fab{padding:0 18px;height:50px;font-size:14px}}" +
    /* Backdrop (solo móvil, detrás de la ventana) */
    ".srn-backdrop{position:fixed;inset:0;background:rgba(10,10,20,.45);z-index:2147483646;opacity:0;visibility:hidden;transition:opacity .25s;backdrop-filter:blur(2px)}" +
    ".srn-backdrop.open{opacity:1;visibility:visible}" +
    /* Ventana */
    ".srn-win{position:fixed;bottom:88px;right:20px;width:384px;max-width:calc(100vw - 32px);height:600px;max-height:calc(100vh - 120px);background:#fff;border-radius:18px;box-shadow:0 18px 50px rgba(0,0,0,.28);z-index:2147483647;display:flex;flex-direction:column;overflow:hidden;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;opacity:0;visibility:hidden;transform:translateY(14px) scale(.98);transform-origin:bottom right;transition:opacity .22s ease,transform .22s ease,visibility .22s}" +
    ".srn-win.open{opacity:1;visibility:visible;transform:none}" +
    /* Móvil: pantalla completa real; la altura la controla el JS con visualViewport para que el teclado no tape el input. */
    "@media(max-width:600px){.srn-win{top:0;left:0;right:0;bottom:0;width:100%;max-width:100%;height:100dvh;max-height:none;border-radius:0;transform:translateY(100%);transition:transform .28s cubic-bezier(.22,.61,.36,1),opacity .2s}.srn-win.open{transform:none}}" +
    /* Header */
    ".srn-head{background:linear-gradient(135deg," + BRAND + " 0%,#2a2a4a 100%);color:#fff;padding:14px 16px;display:flex;align-items:center;gap:11px;flex-shrink:0;padding-top:calc(14px + env(safe-area-inset-top,0px));padding-right:calc(16px + env(safe-area-inset-right,0px));padding-left:calc(16px + env(safe-area-inset-left,0px))}" +
    ".srn-head .srn-av{width:42px;height:42px;border-radius:50%;flex-shrink:0;background:radial-gradient(circle at 32% 26%,#f7ecc0 0%," + ACCENT + " 55%,#9c7c1a 100%);display:flex;align-items:center;justify-content:center;position:relative;box-shadow:0 2px 8px rgba(201,162,39,.45),inset 0 1px 1px rgba(255,255,255,.55)}" +
    ".srn-head .srn-av svg{width:23px;height:23px;color:" + BRAND + ";filter:drop-shadow(0 1px 1px rgba(255,255,255,.4))}" +
    ".srn-head .srn-dot{position:absolute;bottom:1px;right:1px;width:11px;height:11px;border-radius:50%;background:#3ddc84;border:2px solid " + BRAND + ";box-shadow:0 0 0 2px rgba(61,220,132,.28)}" +
    ".srn-head .srn-tt{min-width:0;flex:1}" +
    ".srn-head h3{margin:0;font-size:15.5px;font-weight:700;color:#fff !important;line-height:1.2}" +
    ".srn-head p{margin:2px 0 0;font-size:11.5px;opacity:.8;color:#fff !important;line-height:1.2;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}" +
    ".srn-head .srn-wa{display:flex;align-items:center;justify-content:center;width:40px;height:40px;border-radius:10px;background:rgba(255,255,255,.12);color:#fff;text-decoration:none;transition:background .2s;flex-shrink:0}" +
    ".srn-head .srn-wa:hover{background:#25d366}" +
    ".srn-head .srn-wa svg{width:19px;height:19px}" +
    ".srn-head .srn-x{width:40px;height:40px;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.08);border:none;border-radius:10px;color:#fff;font-size:24px;cursor:pointer;line-height:1;opacity:.9;flex-shrink:0;-webkit-tap-highlight-color:transparent}" +
    ".srn-head .srn-x:hover{opacity:1;background:rgba(255,255,255,.16)}" +
    /* Cuerpo */
    ".srn-body{flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;padding:16px;background:#f6f6f9;display:flex;flex-direction:column;gap:10px;min-height:0}" +
    ".srn-msg{max-width:82%;padding:11px 14px;border-radius:16px;font-size:14.5px;line-height:1.5;white-space:pre-wrap;word-wrap:break-word;animation:srnIn .22s ease both}" +
    "@keyframes srnIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:none}}" +
    ".srn-msg.u{align-self:flex-end;background:" + BRAND + ";color:#fff;border-bottom-right-radius:5px}" +
    ".srn-msg.a{align-self:flex-start;background:#fff;color:#222;border:1px solid #ececf0;border-bottom-left-radius:5px;box-shadow:0 1px 2px rgba(0,0,0,.03)}" +
    ".srn-msg.a a{color:" + BRAND + ";font-weight:600;text-decoration:underline}" +
    ".srn-msg.a strong{color:#111}" +
    ".srn-typing{align-self:flex-start;display:flex;gap:4px;padding:13px 15px;background:#fff;border:1px solid #ececf0;border-radius:16px}" +
    ".srn-typing span{width:7px;height:7px;border-radius:50%;background:#bbb;animation:srnB 1s infinite}" +
    ".srn-typing span:nth-child(2){animation-delay:.2s}.srn-typing span:nth-child(3){animation-delay:.4s}" +
    "@keyframes srnB{0%,60%,100%{opacity:.3;transform:translateY(0)}30%{opacity:1;transform:translateY(-4px)}}" +
    /* Chips */
    ".srn-chips{display:flex;flex-wrap:wrap;gap:7px;padding:0 14px 10px;background:#f6f6f9;flex-shrink:0}" +
    ".srn-chip{font-size:12.5px;background:#fff;border:1px solid " + ACCENT + ";color:#7a6410;border-radius:16px;padding:8px 13px;cursor:pointer;transition:background .15s,color .15s;-webkit-tap-highlight-color:transparent}" +
    ".srn-chip:hover,.srn-chip:active{background:" + ACCENT + ";color:#fff}" +
    /* Footer / input */
    ".srn-foot{padding:10px;border-top:1px solid #ececf0;background:#fff;display:flex;gap:8px;align-items:flex-end;flex-shrink:0;padding-bottom:calc(10px + env(safe-area-inset-bottom,0px));padding-right:calc(10px + env(safe-area-inset-right,0px));padding-left:calc(10px + env(safe-area-inset-left,0px))}" +
    ".srn-foot textarea{flex:1;resize:none;border:1px solid #ddd;border-radius:22px;padding:11px 15px;font-size:15px;font-family:inherit;line-height:1.35;max-height:110px;outline:none;transition:border-color .15s}" +
    ".srn-foot textarea:focus{border-color:" + BRAND + "}" +
    ".srn-send{background:" + BRAND + ";color:#fff;border:none;border-radius:50%;width:44px;height:44px;flex-shrink:0;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:transform .15s,opacity .15s;-webkit-tap-highlight-color:transparent}" +
    ".srn-send:active{transform:scale(.92)}" +
    ".srn-send:disabled{opacity:.4;cursor:default}" +
    ".srn-send svg{width:19px;height:19px}" +
    ".srn-credit{text-align:center;font-size:10.5px;color:#7a6410;padding:6px 8px;background:#fff;font-weight:500;flex-shrink:0;padding-bottom:calc(6px + env(safe-area-inset-bottom,0px))}" +
    /* En móvil el footer ya lleva el safe-area; evitar doble en el credit cuando ambos están visibles */
    "@media(max-width:600px){.srn-foot{padding-bottom:10px}.srn-msg{font-size:15px}}" +
    /* Botones de acción (nivel 3) */
    ".srn-acts{align-self:flex-start;display:flex;flex-wrap:wrap;gap:7px;max-width:92%;margin-top:-2px;animation:srnIn .25s ease both}" +
    ".srn-act{display:inline-flex;align-items:center;gap:6px;font:600 13px/1.2 inherit;font-family:inherit;padding:10px 14px;border-radius:22px;cursor:pointer;border:1.5px solid " + BRAND + ";background:" + BRAND + ";color:#fff;-webkit-tap-highlight-color:transparent;transition:transform .12s,opacity .2s,background .2s}" +
    ".srn-act:active{transform:scale(.96)}" +
    ".srn-act.alt{background:#fff;color:" + BRAND + "}" +
    ".srn-act.ok{background:#1f8a4c;border-color:#1f8a4c;color:#fff;cursor:default}" +
    ".srn-act[disabled]{opacity:.65;cursor:default}" +
    ".srn-act small{font-weight:500;opacity:.8}" +
    /* Globo proactivo (nivel 2) */
    ".srn-nudge{position:fixed;z-index:2147483645;width:268px;max-width:calc(100vw - 24px);background:#fff;color:#1a1a2e;border:1.5px solid " + ACCENT + ";border-radius:16px;box-shadow:0 12px 34px rgba(26,26,46,.22);padding:13px 34px 13px 14px;font-size:13.5px;line-height:1.42;cursor:pointer;opacity:0;transform:translateY(-6px) scale(.97);transform-origin:top right;transition:opacity .28s ease,transform .38s cubic-bezier(.2,1.4,.4,1);font-family:inherit;text-align:left}" +
    ".srn-nudge.show{opacity:1;transform:none}" +
    ".srn-nudge::before{content:'';position:absolute;top:-8px;right:var(--srn-arrow,26px);width:14px;height:14px;background:#fff;border-left:1.5px solid " + ACCENT + ";border-top:1.5px solid " + ACCENT + ";transform:rotate(45deg)}" +
    ".srn-nudge.bottom{transform-origin:bottom right}.srn-nudge.bottom::before{top:auto;bottom:-8px;transform:rotate(225deg)}" +
    ".srn-nudge b{display:block;font-size:12px;letter-spacing:.02em;color:#7a6410;margin-bottom:3px}" +
    ".srn-nudge .srn-ncta{display:inline-block;margin-top:8px;font-weight:700;font-size:12.5px;color:#fff;background:#1a1a2e;border-radius:20px;padding:6px 12px}" +
    ".srn-nudge .srn-nx{position:absolute;top:6px;right:6px;width:26px;height:26px;border:0;background:transparent;color:#888;font-size:18px;line-height:1;cursor:pointer;border-radius:50%}" +
    ".srn-nudge .srn-nx:hover{background:#f1f1f4;color:#222}" +
    "@media (prefers-reduced-motion:reduce){.srn-nudge{transition:opacity .2s}}";

  var styleEl = document.createElement("style");
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  // ── Markdown mínimo (links, bold) + sanitización ────────────────────
  function esc(s) {
    return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }
  function renderMarkdown(text) {
    var t = esc(text);
    t = t.replace(/\[([^\]]+)\]\((https:\/\/[^\s)]+)\)/g, function (_, label, url) {
      return '<a href="' + url + '" target="_blank" rel="noopener">' + label + "</a>";
    });
    t = t.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
    return t;
  }

  // ── Build UI ────────────────────────────────────────────────────────
  var fab = document.createElement("button");
  fab.className = "srn-fab";
  fab.setAttribute("aria-label", "Comprar con IA — abrir asesor de fragancias");
  fab.innerHTML =
    '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 1.5l1.9 6.1 6.1 1.9-6.1 1.9L12 17.5l-1.9-6.1L4 9.5l6.1-1.9z"/><path d="M19 14l.8 2.7 2.7.8-2.7.8-.8 2.7-.8-2.7-2.7-.8 2.7-.8z"/></svg>' +
    '<span class="srn-fab-label">' + FAB_LABEL + "</span>";

  var backdrop = document.createElement("div");
  backdrop.className = "srn-backdrop";

  var win = document.createElement("div");
  win.className = "srn-win";
  win.setAttribute("role", "dialog");
  win.setAttribute("aria-label", "Chat con Mojo, asesor de fragancias Serené");
  win.innerHTML =
    '<div class="srn-head"><div class="srn-av"><svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 1.6l1.7 5.8c.28.95 1.02 1.69 1.97 1.97L21.4 11l-5.73 1.62c-.95.28-1.69 1.02-1.97 1.97L12 20.4l-1.7-5.81c-.28-.95-1.02-1.69-1.97-1.97L2.6 11l5.73-1.62c.95-.28 1.69-1.02 1.97-1.97z"/><path d="M18.6 15.2l.7 2.4 2.4.7-2.4.7-.7 2.4-.7-2.4-2.4-.7 2.4-.7z"/></svg><span class="srn-dot"></span></div>' +
    '<div class="srn-tt"><h3>Mojo · Serené ✨</h3><p>Asesor de fragancias · en línea</p></div>' +
    '<a class="srn-wa" href="' + WHATSAPP_URL + '" target="_blank" rel="noopener" aria-label="Hablar por WhatsApp" title="Hablar con una persona por WhatsApp"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.5 14.4c-.3-.15-1.7-.84-2-.94-.26-.1-.45-.15-.64.15-.19.29-.74.93-.9 1.12-.17.19-.33.21-.62.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.04-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.08-.15-.64-1.55-.88-2.12-.23-.55-.47-.48-.64-.49h-.55c-.19 0-.5.07-.76.36-.26.29-1 .98-1 2.38s1.02 2.76 1.17 2.95c.15.19 2.01 3.07 4.88 4.3.68.29 1.21.47 1.63.6.68.22 1.31.19 1.8.12.55-.08 1.7-.69 1.94-1.36.24-.67.24-1.24.17-1.36-.07-.12-.26-.19-.55-.34zM12 2a10 10 0 0 0-8.6 15.06L2 22l5.06-1.33A10 10 0 1 0 12 2z"/></svg></a>' +
    '<button class="srn-x" aria-label="Cerrar chat">&times;</button></div>' +
    '<div class="srn-body" id="srn-body"></div>' +
    '<div class="srn-chips" id="srn-chips"></div>' +
    '<div class="srn-foot"><textarea id="srn-input" rows="1" placeholder="Escribe tu mensaje…" aria-label="Escribe tu mensaje"></textarea>' +
    '<button class="srn-send" id="srn-send" aria-label="Enviar"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg></button></div>' +
    '<div class="srn-credit">✨ La IA de Serené te asesora y encuentra tu fragancia ideal</div>';

  if (SHOW_FAB) document.body.appendChild(fab);
  document.body.appendChild(backdrop);
  document.body.appendChild(win);

  var bodyEl = win.querySelector("#srn-body");
  var inputEl = win.querySelector("#srn-input");
  var sendBtn = win.querySelector("#srn-send");
  var chipsEl = win.querySelector("#srn-chips");

  var SUGGESTIONS = [
    "✨ Es para mí",
    "🎁 Es para regalar",
    "Aún no lo sé, ayúdame a elegir",
  ];

  var customChips = null; // chips contextuales cuando la charla la abre un saludo proactivo
  function renderChips() {
    chipsEl.innerHTML = "";
    var list = customChips || SUGGESTIONS;
    if (messages.length > 1 && !customChips) { chipsEl.style.display = "none"; return; }
    chipsEl.style.display = "flex";
    list.forEach(function (s) {
      var c = document.createElement("button");
      c.className = "srn-chip";
      c.textContent = s;
      c.onclick = function () { customChips = null; inputEl.value = s; send(); };
      chipsEl.appendChild(c);
    });
  }

  function addMsg(role, text) {
    var d = document.createElement("div");
    d.className = "srn-msg " + (role === "user" ? "u" : "a");
    d.innerHTML = role === "user" ? esc(text) : renderMarkdown(text);
    bodyEl.appendChild(d);
    scrollBottom();
    return d;
  }

  function scrollBottom() {
    bodyEl.scrollTop = bodyEl.scrollHeight;
  }

  function renderAll() {
    bodyEl.innerHTML = "";
    if (!messages.length) {
      messages.push({ role: "assistant", content: GREETING });
    }
    messages.forEach(function (m, i) {
      addMsg(m.role, m.content);
      // los botones solo siguen activos en el último mensaje del bot
      if (m.actions && m.actions.length) renderActions(m.actions, i !== messages.length - 1);
    });
    renderChips();
  }

  function typewriter(el, text) {
    return new Promise(function (resolve) {
      var i = 0;
      var step = Math.max(2, Math.round(text.length / 90));
      function tick() {
        i = Math.min(text.length, i + step);
        el.innerHTML = renderMarkdown(text.slice(0, i));
        scrollBottom();
        if (i < text.length) setTimeout(tick, 14);
        else resolve();
      }
      tick();
    });
  }

  // ── Envío ───────────────────────────────────────────────────────────
  async function send() {
    var text = inputEl.value.trim();
    if (!text || isStreaming) return;
    inputEl.value = "";
    inputEl.style.height = "auto";
    chipsEl.innerHTML = "";
    customChips = null;

    messages.push({ role: "user", content: text });
    addMsg("user", text);
    saveHistory();

    isStreaming = true;
    sendBtn.disabled = true;

    var typing = document.createElement("div");
    typing.className = "srn-typing";
    typing.innerHTML = "<span></span><span></span><span></span>";
    bodyEl.appendChild(typing);
    scrollBottom();

    var answer = "";
    var answerEl = null;
    var actions = [];

    try {
      var context = await buildContext();
      var resp = await fetch(ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ messages: messages.slice(-16), context: context }),
      });
      var data = await resp.json().catch(function () { return {}; });
      if (!resp.ok || !data.reply) {
        throw new Error("HTTP " + resp.status + (data.error ? " · " + data.error : ""));
      }
      answer = data.reply;
      var actions = Array.isArray(data.actions) ? data.actions : [];
      typing.remove();
      answerEl = addMsg("assistant", "");
      await typewriter(answerEl, answer);
      if (actions.length) renderActions(actions, false);
    } catch (e) {
      typing.remove();
      answer =
        "Uy, tuve un problema para responder 😕 Intenta de nuevo en un momento, o escríbenos por WhatsApp y con gusto te ayudamos.";
      if (!answerEl) answerEl = addMsg("assistant", "");
      answerEl.innerHTML = renderMarkdown(answer);
      actions = [];
    }

    if (answer) {
      var msg = { role: "assistant", content: answer };
      if (actions && actions.length) msg.actions = actions;
      messages.push(msg);
      saveHistory();
    }
    isStreaming = false;
    sendBtn.disabled = false;
    inputEl.focus();
  }

  // ── Fix del teclado en móvil (visualViewport) ───────────────────────
  // Cuando el teclado abre, visualViewport.height baja: fijamos esa altura a
  // la ventana para que el input quede siempre visible sobre el teclado.
  function fitViewport() {
    if (!isOpen || !isMobile() || !vv) { return; }
    win.style.height = vv.height + "px";
    win.style.transform = "translateY(" + vv.offsetTop + "px)";
    scrollBottom();
  }
  function clearViewportFit() {
    win.style.height = "";
    win.style.transform = "";
  }
  if (vv) {
    vv.addEventListener("resize", fitViewport);
    vv.addEventListener("scroll", fitViewport);
  }

  // ── Scroll-lock del body (evita que la página se mueva por detrás) ──
  function lockScroll() {
    if (!isMobile()) return;
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.position = "fixed";
    document.body.style.top = -savedScrollY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
  }
  function unlockScroll() {
    if (!document.body.style.position) return;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    window.scrollTo(0, savedScrollY);
  }

  // ── Abrir / cerrar ──────────────────────────────────────────────────
  function open() {
    if (isOpen) return;
    isOpen = true;
    hideNudge();
    try { sessionStorage.setItem("srn_opened", "1"); } catch (e) {}
    lockScroll();
    win.classList.add("open");
    if (isMobile()) backdrop.classList.add("open");
    if (!bodyEl.childElementCount) renderAll();
    setTimeout(function () { fitViewport(); scrollBottom(); inputEl.focus(); }, 60);
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    win.classList.remove("open");
    backdrop.classList.remove("open");
    clearViewportFit();
    unlockScroll();
    if (inputEl) inputEl.blur();
  }
  function toggle() { isOpen ? close() : open(); }

  fab.onclick = toggle;
  win.querySelector(".srn-x").onclick = close;
  backdrop.onclick = close;
  sendBtn.onclick = send;

  // Cerrar con Escape (desktop)
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && isOpen) close();
  });

  // ── Atribución de ventas (sella el carrito de Shopify) ──────────────
  function stampCart(sku) {
    try {
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: { "_recomendado_por": "Mojo (bot IA)", "_aura_sku": sku || "" },
        }),
      }).catch(function () {});
    } catch (e) {}
  }
  bodyEl.addEventListener("click", function (e) {
    var a = e.target && e.target.closest ? e.target.closest("a") : null;
    if (!a) return;
    var href = a.getAttribute("href") || "";
    if (href.indexOf("utm_source=aura-bot") === -1) return;
    var m = href.match(/utm_content=([^&]+)/);
    stampCart(m ? decodeURIComponent(m[1]) : "");
  });

  inputEl.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); }
  });
  inputEl.addEventListener("input", function () {
    inputEl.style.height = "auto";
    inputEl.style.height = Math.min(inputEl.scrollHeight, 110) + "px";
  });

  // ════════════════════════════════════════════════════════════════════
  // NIVEL 1 — Contexto en vivo de la visita
  // Qué está haciendo el cliente en la tienda: se manda con cada mensaje para
  // que Mojo ayude sobre lo que tiene enfrente (producto, carrito, vistos).
  // ════════════════════════════════════════════════════════════════════
  var VISIT_KEY = "srn_visit_v1";
  var pageStart = Date.now();
  var maxScroll = 0;
  var lastNudgeText = "";
  var productInfo = null;      // {title, price, variant, available, handle}
  var cartAtLoad = null;       // nº de unidades al cargar la página

  function ssGet(k, d) { try { var v = sessionStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  function pageType() {
    try {
      var t = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.pageType;
      if (t) return String(t).toLowerCase();
    } catch (e) {}
    var p = location.pathname;
    if (/\/products\//.test(p)) return "product";
    if (/\/collections\//.test(p)) return "collection";
    if (/\/cart\/?$/.test(p)) return "cart";
    if (/\/search/.test(p)) return "searchresults";
    if (p === "/" || p === "") return "home";
    return "page";
  }
  var PAGE = pageType();

  function cleanTitle() {
    var h = document.querySelector("h1");
    return ((h && h.textContent) || document.title || "").replace(/\s+/g, " ").trim().slice(0, 120);
  }

  function loadProduct() {
    if (PAGE !== "product") return Promise.resolve(null);
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return Promise.resolve(null);
    return fetch("/products/" + m[1] + ".js").then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return null;
      var vid = new URLSearchParams(location.search).get("variant");
      var v = (p.variants || []).filter(function (x) { return String(x.id) === vid; })[0] || (p.variants || [])[0] || {};
      productInfo = {
        handle: p.handle, title: p.title,
        price: Math.round((v.price || p.price || 0) / 100),
        variant: v.title && v.title !== "Default Title" ? v.title : "",
        available: v.available !== false,
        variantId: v.id || null,
      };
      // historial de productos vistos en la visita (máx 8, sin repetir)
      var visit = ssGet(VISIT_KEY, { viewed: [] });
      visit.viewed = (visit.viewed || []).filter(function (x) { return x.handle !== p.handle; });
      visit.viewed.push({ handle: p.handle, title: p.title });
      visit.viewed = visit.viewed.slice(-8);
      ssSet(VISIT_KEY, visit);
      return productInfo;
    }).catch(function () { return null; });
  }

  function getCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.ok ? r.json() : null; }).then(function (c) {
      if (!c) return null;
      return {
        count: c.item_count || 0,
        total: Math.round((c.total_price || 0) / 100),
        items: (c.items || []).slice(0, 8).map(function (i) { return { title: i.product_title + (i.variant_title ? " (" + i.variant_title + ")" : ""), qty: i.quantity }; }),
      };
    }).catch(function () { return null; });
  }

  async function buildContext() {
    var cart = await getCart();
    var visit = ssGet(VISIT_KEY, { viewed: [] });
    var ctx = {
      pageType: PAGE,
      pageTitle: PAGE === "product" ? "" : cleanTitle(),
      secondsOnPage: Math.round((Date.now() - pageStart) / 1000),
      viewed: (visit.viewed || []).filter(function (x) { return !productInfo || x.handle !== productInfo.handle; }).map(function (x) { return { title: x.title }; }),
      cart: cart,
    };
    if (PAGE === "searchresults") ctx.search = new URLSearchParams(location.search).get("q") || "";
    if (productInfo) ctx.product = productInfo;
    if (lastNudgeText) ctx.nudge = lastNudgeText;
    return ctx;
  }

  window.addEventListener("scroll", function () {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0) maxScroll = Math.max(maxScroll, (window.scrollY || 0) / h);
  }, { passive: true });

  // ════════════════════════════════════════════════════════════════════
  // NIVEL 2 — Saludo proactivo ante señales de duda
  // Un globo sale del botón "Comprar con IA" (o abajo a la derecha si no hay
  // botón) con un mensaje según lo que hace el cliente. Reglas anti-molestia:
  // máx 2 por visita, 90 s entre uno y otro, nunca si ya abrió el chat, y si
  // lo cierra 2 veces no vuelve a salir en la visita.
  // ════════════════════════════════════════════════════════════════════
  var NUDGE_KEY = "srn_nudge_v1";
  var nudgeEl = null, nudgeTimer = null;
  var exitArmed = false;

  function nudgeState() { return ssGet(NUDGE_KEY, { shown: 0, dismissed: 0, last: 0, done: {} }); }
  function shortName(t) {
    t = String(t || "");
    var m = t.match(/inspirad[oa] en ([^|–—-]+)/i);
    return (m ? m[1] : t).replace(/\s+(por|by)\s+.*$/i, "").replace(/\s+/g, " ").trim().slice(0, 40);
  }
  function fmtCOP(n) { return "$" + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."); }

  function canNudge(id) {
    if (isOpen) return false;
    try { if (sessionStorage.getItem("srn_opened")) return false; } catch (e) {}
    var st = nudgeState();
    if (st.shown >= 2 || st.dismissed >= 2 || st.done[id]) return false;
    if (Date.now() - (st.last || 0) < 90000) return false;
    if (document.hidden) return false;
    var a = document.activeElement;
    if (a && /input|textarea|select/i.test(a.tagName) && !win.contains(a)) return false;
    return true;
  }

  function placeNudge() {
    if (!nudgeEl) return;
    var btn = document.querySelector(".serene-ia-btn");
    var r = btn && btn.offsetParent ? btn.getBoundingClientRect() : null;
    var W = nudgeEl.offsetWidth || 268;
    if (r && r.bottom > 0 && r.top < window.innerHeight * 0.5) {
      var right = Math.max(12, window.innerWidth - r.right - 4);
      if (window.innerWidth - right - W < 12) right = Math.max(12, window.innerWidth - W - 12);
      nudgeEl.classList.remove("bottom");
      nudgeEl.style.top = (r.bottom + 12) + "px"; nudgeEl.style.bottom = "auto";
      nudgeEl.style.right = right + "px"; nudgeEl.style.left = "auto";
      var arrow = (window.innerWidth - right) - (r.left + r.width / 2) - 7;
      nudgeEl.style.setProperty("--srn-arrow", Math.max(14, Math.min(W - 28, arrow)) + "px");
    } else {
      // botón fuera de vista (scroll): globo abajo a la derecha
      nudgeEl.classList.add("bottom");
      nudgeEl.style.top = "auto"; nudgeEl.style.bottom = "calc(18px + env(safe-area-inset-bottom,0px))";
      nudgeEl.style.right = "14px"; nudgeEl.style.left = "auto";
      nudgeEl.style.setProperty("--srn-arrow", "26px");
    }
  }

  function hideNudge() {
    clearTimeout(nudgeTimer);
    if (!nudgeEl) return;
    var el = nudgeEl; nudgeEl = null;
    el.classList.remove("show");
    setTimeout(function () { el.remove(); }, 320);
  }

  function showNudge(id, text, chips) {
    if (!canNudge(id)) return;
    var st = nudgeState(); st.shown++; st.last = Date.now(); st.done[id] = 1; ssSet(NUDGE_KEY, st);
    hideNudge();
    var el = document.createElement("div");
    el.className = "srn-nudge"; el.setAttribute("role", "status");
    el.innerHTML = "<b>Mojo · asesor Serené ✨</b>" + esc(text) + '<br><span class="srn-ncta">Hablar con Mojo →</span><button class="srn-nx" aria-label="Cerrar">×</button>';
    document.body.appendChild(el); nudgeEl = el;
    placeNudge();
    requestAnimationFrame(function () { el.classList.add("show"); });
    try { document.dispatchEvent(new CustomEvent("serene:mojo-nudge", { detail: { id: id } })); } catch (e) {}
    el.querySelector(".srn-nx").onclick = function (e) {
      e.stopPropagation();
      var s2 = nudgeState(); s2.dismissed++; ssSet(NUDGE_KEY, s2); hideNudge();
    };
    el.onclick = function () {
      lastNudgeText = text;
      // si Mojo en vivo está disponible, el globo abre la LLAMADA con Mojo (con el contexto del globo)
      if (window.MojoLive && MojoLive.open) {
        hideNudge();
        try { fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { "_mojo_nudge": id } }) }).catch(function () {}); } catch (e) {}
        MojoLive.open({ nudge: text, nudgeId: id });
        return;
      }
      // el saludo proactivo pasa a ser el primer mensaje de Mojo en la charla
      messages.push({ role: "assistant", content: (messages.length ? "" : "¡Hola! Soy Mojo ✨ ") + text });
      saveHistory();
      customChips = chips || null;
      bodyEl.innerHTML = "";
      open(); // open() re-renderiza la charla porque el cuerpo quedó vacío
      // medición: con qué disparador se abrió (se ve en el pedido)
      try { fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { "_mojo_nudge": id } }) }).catch(function () {}); } catch (e) {}
    };
    nudgeTimer = setTimeout(hideNudge, 14000);
  }

  window.addEventListener("resize", placeNudge);
  window.addEventListener("scroll", function () { if (nudgeEl) placeNudge(); }, { passive: true });

  function evalTriggers() {
    var secs = (Date.now() - pageStart) / 1000;
    if (secs < 10 || isOpen) return;
    var visit = ssGet(VISIT_KEY, { viewed: [] });
    var nViewed = (visit.viewed || []).length;

    if (PAGE === "cart" && secs >= 25) {
      getCart().then(function (c) {
        if (!c || !c.count) return;
        var gap = 79900 - c.total;
        if (gap > 0) showNudge("cart_shipping", "Te faltan " + fmtCOP(gap) + " para el envío gratis 🚚 ¿Te recomiendo algo que combine con lo que llevas?", ["Sí, recomiéndame algo", "¿Hay pago contra entrega?", "¿Cuánto tarda el envío?"]);
        else showNudge("cart_doubts", "¿Alguna duda antes de finalizar tu compra? Te ayudo con envío, pago contra entrega o la fijación de tu aroma.", ["¿Hay pago contra entrega?", "¿Cuánto tarda el envío?", "¿Cuánto dura el aroma?"]);
      });
      return;
    }
    if (PAGE === "product" && productInfo && secs >= 12) {
      getCart().then(function (c) {
        if (c && cartAtLoad !== null && c.count > cartAtLoad) return; // ya lo agregó
        var n = shortName(productInfo.title);
        if (nViewed >= 3) showNudge("compare", "Llevas " + nViewed + " fragancias vistas 👀 ¿Te ayudo a decidir cuál va más contigo?", ["Ayúdame a decidir", "¿Cuál dura más?", "Es para regalar"]);
        else showNudge("product_dwell", "¿Te ayudo a elegir? 🎙️ Te cuento cómo huele " + (n ? "el inspirado en " + n : "este Serené") + " y si va contigo.", ["¿Cómo huele?", "¿Para qué ocasión es?", "¿Cuánto dura?"]);
      });
      return;
    }
    if ((PAGE === "collection" || PAGE === "home" || PAGE === "searchresults") && secs >= 40 && maxScroll > 0.35) {
      if (nViewed >= 3) showNudge("compare", "Llevas " + nViewed + " fragancias vistas 👀 ¿Te ayudo a elegir la ideal en un minuto?", ["Ayúdame a elegir", "Es para regalar", "Algo fresco para el día"]);
      else showNudge("browse", "¿Buscas algo en especial? Dime un perfume que te encante y te muestro su versión Serené ✨", ["Algo como Sauvage", "Algo dulce", "Para regalar"]);
    }
  }

  // Intención de salida (escritorio): el mouse sale por arriba de la ventana
  document.addEventListener("mouseout", function (e) {
    if (e.relatedTarget || e.clientY > 0 || isMobile()) return;
    if ((Date.now() - pageStart) / 1000 < 15 || PAGE === "cart") return;
    if (exitArmed) return; exitArmed = true;
    showNudge("exit", "¿Te vas sin encontrar tu aroma? Dime qué perfume te gusta y te digo cuál es su versión Serené ✨", ["Algo como Sauvage", "Algo dulce", "Es para regalar"]);
  });

  loadProduct();
  getCart().then(function (c) { cartAtLoad = c ? c.count : 0; });
  setInterval(evalTriggers, 2500);

  // ════════════════════════════════════════════════════════════════════
  // NIVEL 3 — Acciones: Mojo propone, el cliente toca el botón.
  // El bot nunca modifica el carrito solo: todo pasa por un clic del cliente.
  // ════════════════════════════════════════════════════════════════════
  var ICON_CART = "🛒", ICON_GO = "→";

  function actLabel(a) {
    if (a.type === "add") {
      var name = a.current ? (productInfo ? shortName(productInfo.title) : "este perfume") : (a.sku + (a.title ? " · " + shortName(a.title.split("—")[0]) : ""));
      return ICON_CART + " Agregar " + esc(name) + (a.qty > 1 ? " (x" + a.qty + ")" : "") + (a.price ? " <small>" + esc(a.price) + "</small>" : "");
    }
    if (a.type === "cart") return "Ver mi carrito";
    if (a.type === "checkout") return "Finalizar compra " + ICON_GO;
    return "";
  }

  function renderActions(list, inactive) {
    var wrap = document.createElement("div");
    wrap.className = "srn-acts";
    list.forEach(function (a) {
      if (a.type === "add" && a.current && !productInfo && !inactive) return; // no hay producto en pantalla
      var b = document.createElement("button");
      b.className = "srn-act" + (a.type === "cart" ? " alt" : "");
      b.innerHTML = actLabel(a);
      if (inactive) { b.disabled = true; }
      else b.onclick = function () { runAction(a, b); };
      wrap.appendChild(b);
    });
    if (wrap.childElementCount) { bodyEl.appendChild(wrap); scrollBottom(); }
  }

  function variantFor(a) {
    if (a.current && productInfo) return Promise.resolve({ id: productInfo.variantId, title: productInfo.title, available: productInfo.available });
    var m = String(a.url || "").match(/\/products\/([^/?#]+)/);
    if (!m) return Promise.resolve(null);
    return fetch("/products/" + m[1] + ".js").then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
      if (!p) return null;
      var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
      return v ? { id: v.id, title: p.title, available: v.available !== false } : null;
    }).catch(function () { return null; });
  }

  function botNote(text, acts) {
    var msg = { role: "assistant", content: text };
    if (acts) msg.actions = acts;
    messages.push(msg); saveHistory();
    addMsg("assistant", text);
    if (acts) renderActions(acts, false);
  }

  function runAction(a, btn) {
    if (a.type === "cart" || a.type === "checkout") {
      // Se abre el carrito del tema (no /checkout directo) para que el cliente
      // vea y elija "Paga al recibir" (contra entrega) o pago en línea.
      var drawer = document.querySelector("cart-drawer");
      if (drawer && drawer.open && PAGE !== "cart") { close(); setTimeout(function () { drawer.open(); }, 280); }
      else if (PAGE === "cart") { close(); }
      else location.href = "/cart";
      return;
    }
    if (a.type !== "add" || btn.disabled) return;
    btn.disabled = true; var old = btn.innerHTML; btn.innerHTML = "Agregando…";
    variantFor(a).then(function (v) {
      if (!v || !v.id) throw new Error("sin variante");
      if (!v.available) throw new Error("agotado");
      var drawer = document.querySelector("cart-drawer");
      var payload = { id: v.id, quantity: a.qty || 1, properties: { _mojo: "1" } };
      if (drawer && drawer.getSectionsToRender) {
        payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        payload.sections_url = location.pathname;
      }
      return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || "error"); return { j: j, v: v, drawer: drawer }; }); });
    }).then(function (res) {
      btn.className = "srn-act ok"; btn.innerHTML = "✓ Agregado";
      stampCart(a.sku || (productInfo && productInfo.handle) || "");
      var name = a.current ? shortName(res.v.title) : (a.sku + " " + shortName((a.title || res.v.title).split("—")[0]));
      botNote("✅ Agregué " + name + " a tu carrito. ¿Finalizamos tu compra o quieres ver algo más? ✨", [{ type: "checkout" }, { type: "cart" }]);
      // refrescar el carrito del tema (contador + carrito lateral) sin recargar
      try {
        if (res.drawer && res.j.sections && res.drawer.renderContents) {
          res.drawer.classList.remove("is-empty");
          res.drawer.renderContents(res.j);
        } else {
          fetch(location.pathname + "?sections=cart-icon-bubble").then(function (r) { return r.json(); }).then(function (sec) {
            var el = document.getElementById("cart-icon-bubble");
            if (el && sec["cart-icon-bubble"]) {
              var tmp = document.createElement("div"); tmp.innerHTML = sec["cart-icon-bubble"];
              var inner = tmp.querySelector("#cart-icon-bubble") || tmp; el.innerHTML = inner.innerHTML;
            }
          }).catch(function () {});
        }
      } catch (e) {}
      try { document.dispatchEvent(new CustomEvent("serene:mojo-added", { detail: { sku: a.sku || "" } })); } catch (e) {}
    }).catch(function (e) {
      btn.disabled = false; btn.innerHTML = old;
      var msg = /agotado/.test(String(e && e.message)) ? "Uy, esa presentación está agotada en este momento 😕 ¿Te recomiendo una parecida?" : "No pude agregarlo al carrito 😕 Ábrelo y toca \"Añadir al carrito\", o escríbeme y lo intentamos de nuevo.";
      botNote(msg);
    });
  }

  // API pública
  window.SereneChat = {
    open: open,
    close: close,
    toggle: toggle,
    ask: function (text) {
      open();
      if (text) { inputEl.value = text; send(); }
    },
  };
})();
